module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [(_vm.isInfoPanelOpen) ? _c('info-panel', {
    staticClass: "info-panel"
  }) : _vm._e(), _vm._v(" "), _c('info-control', {
    staticClass: "info-control",
    attrs: {
      "open": _vm.isInfoPanelOpen
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleInfoPanel($event)
      }
    }
  }), _vm._v(" "), _c('top-bar', {
    ref: "control",
    attrs: {
      "initial-text": _vm.text
    },
    on: {
      "textChange": _vm.onPreviewControlInput
    }
  }), _vm._v(" "), (_vm.text.length > 0) ? _c('section', {
    ref: "previews",
    staticClass: "previews",
    style: (("grid-template-columns: repeat(" + _vm.colCount + ", 1fr)"))
  }, [_vm._l((_vm.fonts), function(font) {
    return [_c('div', {
      staticClass: "preview-wrapper"
    }, [_c('preview', {
      attrs: {
        "text": _vm.text,
        "font-name": font.name,
        "font-author": font.author
      }
    })], 1)]
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-427a9fc7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 31
// module chunks = 0